import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { notifySuccess } from "../../../components/ui/popup/toastPopup";
import { postMoneyIn } from "../../../service/moneyInAPI";
import { useForm } from "react-hook-form";
import BreadcrumbsTitle from "../../../components/ui/breadcrumbsTitle";
import { useNavigate } from "react-router-dom";
import { useSchema } from "../../../components/hooks/use-schema";
import { moneyInSchema } from "../../../components/validation/moneyInSchema";
import MoneyInForm from "./moneyInForm";
import { GridContainerSize } from "../../../components/utils/gridContainerSize";
import { Box } from "@mui/material";

function MoneyInCreate(props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(useSchema(moneyInSchema));
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusButton, setStatusButton] = useState(true);
  const navigate = useNavigate();
  const onConfirmForm = async (register) => {
    setIsSubmitting(true);
    let dataAPI = {
      status: statusButton,
      money_in_lang: {
        name: register.moneyIn,
        language_code: "ALL",
      },
    };
    let statusAPI = await postMoneyIn(dataAPI);
    if (statusAPI === "OK") {
      notifySuccess({
        title: t("toast_successfully_added_information"),
      });
      navigate("/money-in");
    }
    await new Promise((resolve) => setTimeout(resolve, 2000));
    setIsSubmitting(false);
  };
  return (
    <div align="left">
      <BreadcrumbsTitle
        props={{
          title: t("money_in_create"),
          dataLink: [
            {
              text: t("money_in"),
              link: "/money-in",
            },
            { text: t("money_in_create"), link: null },
          ],
        }}
      />
      <GridContainerSize>
        <Box p={2}>
          <MoneyInForm
            props={{
              handleSubmit,
              onConfirmForm,
              register,
              errors,
              statusButton,
              setStatusButton,
              isSubmitting,
            }}
          />
        </Box>
      </GridContainerSize>
    </div>
  );
}

export default MoneyInCreate;
